
import { Options, Vue } from 'vue-class-component'
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { ChairService, VariantType } from '@/service/ChairService'
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment'

interface Part {
  id: string,
  text: string,
  color: string
}

const size = {
  width: 500,
  height: 600
}

@Options({
  name: 'Configurator3d',
  data () {
    return {
      chair: null,
      background: null,
      carColor: '',
      backgroundColor: '',
      modal: false,
      target: null,
      chairData: null,
      orbit: null,
      renderer: null,
      camera: null,
      chosenSeries: null,
      chosenAccessories: null,
      chosenVariant: null,
      variantSelect: false,
      mesh: null,
      rotate: true,
      lipsum: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Nullam eget nisl. Donec vitae arcu. Integer in sapien. Integer rutrum, orci vestibulum ullamcorper ultricies, lacus quam ultricies odio, vitae placerat pede sem sit amet enim. Nullam dapibus fermentum ipsum. Nam sed tellus id magna elementum tincidunt.',
      lipsumSerie: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Nullam eget nisl. Donec vitae arcu. Integer in sapien. Integer rutrum, orci vestibulum ullamcorper ultricies, lacus quam ultricies odio, vitae placerat pede sem sit amet enim. Nullam dapibus fermentum ipsum. Nam sed tellus id magna elementum tincidunt.',
      lipsumArr: [
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Nullam eget nisl. Donec vitae arcu. Integer in sapien. Integer rutrum, orci vestibulum ullamcorper ultricies, lacus quam ultricies odio, vitae placerat pede sem sit amet enim. Nullam dapibus fermentum ipsum. Nam sed tellus id magna elementum tincidunt.',
        'Ut ut erat blandit, pretium metus nec, lobortis purus. Aliquam cursus pellentesque turpis id suscipit. Mauris gravida, ipsum et volutpat ornare, leo nisi pulvinar metus, non laoreet odio ex eu nunc. Morbi egestas nibh at arcu faucibus mollis. Aliquam finibus leo ut erat dapibus, vitae rhoncus tellus elementum.',
        'Proin ipsum nibh, elementum id pretium non, tincidunt et odio. Nunc iaculis nisi quis massa porta dictum. Donec pellentesque eget augue pellentesque venenatis. Nulla sapien nulla, hendrerit sit amet eros quis, pellentesque congue purus. Cras porta ante semper, dapibus tellus at, vulputate lorem.',
        'Aliquam ultrices molestie risus vitae auctor. Maecenas ac quam enim. Sed mattis lobortis odio. Quisque suscipit fermentum tempus. Vestibulum ac lobortis odio. Vivamus maximus metus et dignissim dictum. Pellentesque commodo est eu luctus tempus. Mauris nisi elit, egestas eget mattis sit amet, convallis a tellus.',
        'Mauris et finibus urna. Phasellus maximus, lorem et volutpat aliquam, leo sem convallis est, nec consequat neque ex nec enim. Nullam et facilisis purus, nec auctor ex. Proin laoreet hendrerit dignissim. Ut quis nulla quis urna pulvinar ornare. Quisque porttitor tempus erat, eget pretium sapien suscipit ut.'
      ]
    }
  },
  created () {
    this.chairData = ChairService.getChair(this.$route.params.id)
    this.chosenSeries = this.chairData.colors[0].name
    if (this.chairData.variants) {
      this.chosenVariant = this.chairData.variants[0]
    }
    if (this.chairData.accessories) {
      this.chosenAccessories = this.chairData.accessories[0]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    changeLipsum (type: string) {
      const index = Math.floor(Math.random() * this.lipsumArr.length)
      if (type === 'material') { this.lipsum = this.lipsumArr[index] } else { this.lipsumSerie = this.lipsumArr[index] }
    },
    changeRotation () {
      this.rotate = !this.rotate
    },
    triggerAccessory (accessory: any, accessories: any) {
      if (accessories.id !== 'ostatni') {
        accessories.values.forEach((acc: any) => {
          acc.parts.forEach((part: any) => {
            this.chair.getObjectByName(part).visible = false
          })
        })
      }
      if (!accessory) {
        return
      }
      accessory.parts.forEach((part: any) => {
        this.chair.getObjectByName(part).visible = !this.chair.getObjectByName(part).visible
      })
    },
    accessoryVisible (accessory: any) {
      if (!this.chair) { return false }
      return accessory.parts.every((part: any) => {
        return !!this.chair.getObjectByName(part).visible
      })
    },
    accessoriesVisible (accessories: any) {
      if (!this.chair) { return false }
      return accessories.values.every((acc: any) => {
        return acc.parts.every((part: any) => {
          return !this.chair.getObjectByName(part).visible
        })
      })
    },
    initColor () {
      const loader = new THREE.TextureLoader()

      this.chairData.config.forEach((config: any) => {
        config.parts.forEach((part: any) => {
          loader.load('../materials/' + config.color, (texture) => {
            texture.wrapS = THREE.RepeatWrapping
            texture.wrapT = THREE.RepeatWrapping
            texture.encoding = THREE.sRGBEncoding
            this.chair.getObjectByName(part).material.map = texture
          })
        })
      })
    },
    applyVariant (variant: any) {
      // TODO: Config to change color or model (whole 3d swap)
      if (variant.type === VariantType.MATERIAL) {
        this.chair.getObjectByName('nohy').material = new THREE.MeshStandardMaterial({
          ...ChairService.getChairVariantMaterial(variant.id)
        })
      } else {
        const loader = new GLTFLoader()
        console.log('../3d_models/' + this.chairData.file.split('-')[0] + '-' + variant.id + '.glb')
        loader.load('../3d_models/' + this.chairData.file.split('-')[0] + '-' + variant.id + '.glb', (gltf) => {
          const chair = gltf.scene
          console.log(gltf.scene.children.map(child => child.name))
          chair.scale.set(this.chairData.scale, this.chairData.scale, this.chairData.scale)
          chair.position.y = -0.4
          chair.position.x = 0
          chair.position.z = 0
          chair.traverse((obj) => {
            if (obj.name === 'kolecka' || obj.name === 'podnoz') {
              obj.castShadow = true
            }
            obj.castShadow = true
          })
          this.chair.removeFromParent()
          this.chair = chair
          this.scene.add(gltf.scene)
          this.initColor()
          this.initAccessories()
        })
      }
      this.chosenVariant = variant
    },
    applyColor (config: any, color: any) {
      const loader = new THREE.TextureLoader()
      console.log(config)

      config.parts.forEach((part: any) => {
        loader.load('../materials/' + color.file, (texture) => {
          texture.wrapS = THREE.RepeatWrapping
          texture.wrapT = THREE.RepeatWrapping
          texture.encoding = THREE.sRGBEncoding
          this.chair.getObjectByName(part).material.map = texture
        })
        config.color = color.file
        config.colorName = color.name
      })
    },
    applyBGColor () {
      this.background.set(new THREE.Color(this.backgroundColor))
    },
    animate () {
      this.renderer.render(this.scene, this.camera)
      this.orbit.update()
      if (this.rotate) {
        this.chair.rotation.y += 0.005
      }
      requestAnimationFrame(this.animate)
    },
    init () {
      this.renderer = new THREE.WebGLRenderer({ canvas: this.$refs.three, antialias: true })
      this.renderer.shadowMap.enabled = true
      this.renderer.setSize(size.width, size.height)
      this.renderer.toneMappingExposure = 0.5
      this.renderer.toneMapping = THREE.ReinhardToneMapping

      this.renderer.outputEncoding = THREE.sRGBEncoding

      this.scene = new THREE.Scene()

      const pmremGenerator = new THREE.PMREMGenerator(this.renderer)

      this.scene.background = new THREE.Color(this.chairData.background)
      this.scene.environment = pmremGenerator.fromScene(new RoomEnvironment(), 0.04).texture

      this.background = this.scene.background

      this.camera = new THREE.PerspectiveCamera(
        45,
        size.width / size.height,
        0.1,
        1000
      )

      this.orbit = new OrbitControls(this.camera, this.renderer.domElement)

      // this.orbit.autoRotate = true
      this.orbit.maxDistance = 3
      this.orbit.enablePan = false
      this.orbit.enableDamping = true

      // this.orbit.addEventListener('change', () => {
      //  console.log(this.orbit.object.position)
      // })

      this.camera.position.set(0.6, 0.35, 1.3)
      this.orbit.update()

      const hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff)
      hemiLight.position.set(0, 20, 0)
      this.scene.add(hemiLight)

      const dirLight = new THREE.DirectionalLight(0xffffff)
      dirLight.position.set(0, 10, 5)
      dirLight.castShadow = true
      dirLight.shadow.mapSize.width = 4096
      dirLight.shadow.mapSize.height = 4096
      dirLight.shadow.camera.near = 0.1
      dirLight.shadow.camera.far = 90
      dirLight.shadow.radius = 4
      this.scene.add(dirLight)

      // Ground
      const mesh = new THREE.Mesh(new THREE.PlaneGeometry(100, 100), new THREE.ShadowMaterial({ color: 0x000000, opacity: 0.15 }))
      mesh.rotation.x = -Math.PI / 2
      mesh.receiveShadow = true
      mesh.position.y = -0.4
      this.scene.add(mesh)

      const loader = new GLTFLoader()
      loader.load('../3d_models/' + this.chairData.file, (gltf) => {
        const chair = gltf.scene
        // console.log(gltf.scene.children.map(child => child.name))
        chair.scale.set(this.chairData.scale, this.chairData.scale, this.chairData.scale)
        chair.position.y = -0.4
        chair.position.x = 0
        chair.position.z = 0
        chair.traverse((obj) => {
          if (obj.name === 'kolecka' || obj.name === 'podnoz') {
            obj.castShadow = true
          }
          obj.castShadow = true
          obj.rotateOnAxis(new THREE.Vector3(0, 1, 0), 0.005)
        })
        this.chair = chair
        this.scene.add(gltf.scene)
        this.initColor()
        this.initAccessories()
        this.animate()
      })
    },
    initAccessories () {
      if (this.chairData.accessories) {
        this.chairData.accessories.forEach((accessories: any) => {
          accessories.values.forEach((accessory: any) => {
            accessory.parts.forEach((part: any) => {
              // console.log(this.chair.getObjectByName(part))
              this.chair.getObjectByName(part).visible = false
            })
          })
        })
      }
    }
  }
})

export default class Configurator3d extends Vue {}
